import { useEffect, useState } from "react";

function computeParts(target) {
  const now = Date.now();
  const diff = Math.max(0, new Date(target).getTime() - now);
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  const s = Math.floor((diff % 60000) / 1000);
  return { total: diff, h, m, s };
}

export function useCountdown(target) {
  const [parts, setParts] = useState(() => computeParts(target));
  useEffect(() => {
    setParts(computeParts(target));
    const t = setInterval(() => setParts(computeParts(target)), 1000);
    return () => clearInterval(t);
  }, [target]);
  return parts;
}

export function CountdownBadge({ expiresAt, className = "" }) {
  const { total, h, m, s } = useCountdown(expiresAt);
  if (total <= 0) {
    return (
      <span className={"q-chip text-slate-400 " + className} data-testid="countdown-expired">
        Expirado
      </span>
    );
  }
  const hs = String(h).padStart(2, "0");
  const ms = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return (
    <span
      className={"q-chip q-accent-text border-[color:var(--accent)]/40 font-mono " + className}
      data-testid="countdown-badge"
    >
      ⏳ {hs}:{ms}:{ss}
    </span>
  );
}
